let isMouseDown = false;
let isDragged = false;
let position = {
  left: 0,
  mouseX: 0,
};

const blurLinks = (links) => {
  links.forEach((link) => {
    link.blur();
  });
};

const container = document.querySelector(".c-button-list");

if (container) {
  const scrollContainer = container.querySelector(".c-button-list_horizontal-scroll");

  if (scrollContainer) {
    const links = container.querySelectorAll("a");

    links.forEach((link) => {
      //   make links undraggable
      link.addEventListener("dragstart", function (e) {
        e.preventDefault();
      });

      link.addEventListener("click", function (e) {
        //   Stop accidental clicks when dragging
        if (isDragged) {
          e.preventDefault();
        }
      });
    });

    scrollContainer.addEventListener("mouseleave", function (e) {
      isMouseDown = false;
      blurLinks(links);
    });

    container.addEventListener("mousedown", function (e) {
      isMouseDown = true;
      scrollContainer.classList.add("grabbing");

      position = {
        //get current scroll position
        left: scrollContainer.scrollLeft,
        //   Get mouse position
        mouseX: e.pageX,
      };
    });

    container.addEventListener("mouseup", function (e) {
      isMouseDown = false;
      scrollContainer.classList.remove("grabbing");
      //Check if container was dragged
      // if dragged then preventDefault for links
      const draggedAmt = position.mouseX - e.pageX;
      if (draggedAmt > 15 || draggedAmt < -15) {
        isDragged = true;
      } else {
        isDragged = false;
        // remove focus on all links after drag
        blurLinks(links);
      }
    });

    container.addEventListener("mousemove", function (e) {
      if (isMouseDown) {
        const distanceX = e.pageX - position.mouseX;
        scrollContainer.scrollLeft = position.left - distanceX;
      }
    });
  }
}
